// Root
export const Asset = -10000;
export const Liability = -20000;
export const Expense = -30000;
export const Income = -40000;

// Asset
export const FixedAsset = -11000;
export const CurrentAsset = -12000;

// Liability
export const FixedLiability = -21000;
export const CurrentLiability = -22000;

// Expense
export const DirectExpense = -31000;
export const IndirectExpense = -32000;
export const OtherExpense = -33000;

// Income
export const OperatingIncome = -41000;
export const NonOperatingIncome = -42000;

//Fixed Asset
export const PropertysLand = -11100;
export const Equipment = -11200;

// Current Asset
export const Cash = -12100;
export const Bank = -12200;
export const Clients = -12300;
export const Inventory = -12400;
export const AccountReceivable = -12500;

//Fixed Liability
export const Capital = -21100;

// Current Liability
export const Suppliers = -22100;
export const AccountPayable = -22200;
export const PrepaidIncome = -22300;

//DirectExpense
export const FactoryWages_DirectLabor = -31100;
export const ManufacturingOverhead = -31200;

//InDiract Expense
export const OperatingExpense = -32100;
export const NonOperatingExpense = -32200;

//Other Expense
export const PrepaidExpense = -33100;
export const COGS = -33200;
export const Tax = -33300;

//Operating Income
export const Sales = -41100;
export const SalesReturn = -41200;

//Inventory
export const PurchasedRawMaterials = -12410;
export const WorkInProcess = -12420;
export const FinishedGoods = -12430;

//OperatingExpense
export const OfficeAndAdministration = -32110;
export const SellingAndDistribution = -32120;

//ManufacturingOverhead
export const IndirectMetarial = -31210;
export const IndirectLabor = -31220;
export const FactoryRent = -31230;
export const FactoryExpense = -31240;


export const Salary = -32111;